import React, { FunctionComponent, useState } from 'react';
import { useForm } from 'react-hook-form';

import { SlideIn, SubmitButton } from 'components';
import {
  getOvernightParkingAddress,
  getBusinessType,
  getIsSmallBusiness,
} from 'scenes/motor/selectors';
import { AustralianState, YES_NO_OPTIONS } from 'scenes/common/types';
import { MotorFullPageProps, MotorFunnelState } from 'scenes/motor/types';
import {
  SegmentedControlQuestion,
  SelectQuestion,
} from 'scenes/common/components/Questions';
import { getApiData } from 'scenes/common/helpers/apiData';

import ExemptionModal from './ExemptionModal';

const BUSINESS_TYPE = 'businessType';
const IS_SMALL_BUSINESS = 'isSmallBusiness';

const getBusinessInfo = (state: MotorFunnelState) => ({
  businessType: getBusinessType(state),
  isSmallBusiness: getIsSmallBusiness(state),
  overnightParkingAddress: getOvernightParkingAddress(state),
});

const BusinessTypeStep: FunctionComponent<MotorFullPageProps> = ({
  referenceData,
  funnelState,
  onNext,
}) => {
  const {
    formState: hooksForm,
    handleSubmit,
    control,
    watch,
    errors,
  } = useForm({
    mode: 'onChange',
  });
  const {
    businessType,
    isSmallBusiness,
    overnightParkingAddress,
  } = getBusinessInfo(funnelState);
  const [showModal, setShowModal] = useState(false);
  const { businessTypes } = getApiData(referenceData);
  const watchedBusinessType = watch(BUSINESS_TYPE, businessType);

  return (
    <form onSubmit={handleSubmit(onNext)}>
      <SelectQuestion
        options={businessTypes}
        control={control}
        isLoading={false}
        stateKey={BUSINESS_TYPE}
        question="What type of business is the car used for?"
        defaultValue={businessType}
      />

      {overnightParkingAddress.state === AustralianState.NSW &&
        Boolean(watchedBusinessType) && (
          <SlideIn>
            <SegmentedControlQuestion
              errors={errors}
              control={control}
              stateKey={IS_SMALL_BUSINESS}
              options={YES_NO_OPTIONS}
              defaultValue={isSmallBusiness}
              question="Are you a small business?"
              helpLink={{
                id: 'exemption-link',
                text: 'Important information about exemption',
                ariaLabel:
                  'Important information about exemption - Opens dialog',
                onClick: () => setShowModal(true),
              }}
            />
          </SlideIn>
        )}
      <SubmitButton enabled={hooksForm.isValid}>Next</SubmitButton>
      <ExemptionModal isOpen={showModal} onClose={() => setShowModal(false)} />
    </form>
  );
};

export default BusinessTypeStep;
